<template>
	<div
		:class="{ show: showUpdatePassword }"
		class="update-password bg-white box-shadow border-radius"
	>
		<div class="d-flex flex-column">
			<div class="d-flex gap-3 p-3">
				<Avatar
					:label="$helper.firstTwoLetters(userLogged?.username)"
					size="large"
					class="bg-primary text-white"
				/>
				<div class="d-flex flex-column">
					<div class="d-flex align-items-center gap-3">
						<p class="mb-0">
							<b>{{ userLogged?.username }}</b>
						</p>
					</div>
					<p class="text-muted mb-0">{{ role }}</p>
				</div>
			</div>
			<hr class="m-0" />
			<div
				class="change-color p-3 cursor-pointer"
				@click="toggleUpdatePasswordDialog(true)"
			>
				<div><b>Cambiar contraseña</b></div>
			</div>
			<hr class="m-0" />
			<div class="p-3 cursor-pointer change-color" @click="logout()">
				<div>Cerrar sesión</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Avatar from "primevue/avatar";
	import { mapState, mapMutations, mapActions } from "vuex";

	export default {
		components: {
			Avatar,
		},
		computed: {
			...mapState(["userLogged", "showUpdatePassword"]),
			role() {
				if (this.userLogged.id_administrador != null) {
					return "Administrador";
				} else {
					return "Monitor";
				}
			},
		},
		methods: {
			...mapMutations([
				"toggleSidebar",
				"toggleUpdatePassword",
				"toggleUpdatePasswordDialog",
			]),
			...mapActions(["logout"]),
		},
	};
</script>

<style lang="scss" scoped>
	.update-password {
		position: fixed;
		top: 6.5rem;
		right: 1rem;
		overflow: hidden;
		visibility: hidden;
		opacity: 0;
		transform: translateY(-1rem);
		transition: $transition;
		min-width: 20rem;

		&.show {
			visibility: visible;
			opacity: 1;
			transform: translateY(0);
		}

		.change-color {
			transition: $transition;

			&:hover {
				background-color: $primary;
				color: white;
			}
		}
	}
</style>
